// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_market_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BiddingSpotMarketService } from "./bidding_spot_market_service_pb";

/**
 * 受渡日の期間 (開始日・終了日とも含む) の約定価格を、 受渡日の昇順・コマ番号の昇順で返す。
 * 期間は開始日から 31 日以内。 取得に失敗した時は空の一覧にせずエラーを返す。
 *
 * @generated from rpc bffuser.v1.BiddingSpotMarketService.ListBiddingSpotMarketPrices
 */
export const listBiddingSpotMarketPrices = BiddingSpotMarketService.method.listBiddingSpotMarketPrices;
